var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(!_vm.editUser)?_c('user-details',{attrs:{"user":_vm.user,"loading":_vm.loading},on:{"editCard":_vm.userEdit}}):_c('user-edit',{attrs:{"user":_vm.user},on:{"editCard":_vm.userEdit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }